import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface ContactDetailsForCoordinatorStore {
    contactDetails : any,
    setContactDetails : (x:any) => void
    previousContactDetails : any,
    setPreviousContactDetails : (x:any) => void
    clearStore: () => void
}

let  store: StateCreator<ContactDetailsForCoordinatorStore, [], [], ContactDetailsForCoordinatorStore> | StoreApi<ContactDetailsForCoordinatorStore> = (set: SetState<ContactDetailsForCoordinatorStore>) => ({
    contactDetails: null,
    setContactDetails: (x) => {
    set(() => ({ contactDetails : x }))
    },
    previousContactDetails: null,
    setPreviousContactDetails: (x) => {
    set(() => ({ previousContactDetails : x }))
    },
  clearStore: () => {
    set(() => ({ contactDetails: null, previousContactDetails: null }));
  }
})

export const useContactDetailsForCoordinatorStore  = create(store)